import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import {
  ASSET_DATA_PROVIDER_LABELS,
  ASSET_DATA_PROVIDERS,
  ASSET_DATA_PROVIDERS_LOGOS
} from '@/pages/Assets/Assets.constants';

const AssetProviderLogo = ({
  label
}: {
  label: string;
}): React.JSX.Element | null => {
  const provider = ASSET_DATA_PROVIDERS_LOGOS[label];
  if (provider?.image) {
    return (
      <Tooltip
        key={label}
        title={
          ASSET_DATA_PROVIDER_LABELS[
            label as keyof typeof ASSET_DATA_PROVIDER_LABELS
          ]
        }
      >
        <img
          key={label}
          alt={provider.alt}
          src={provider.image}
          style={{
            marginRight: '0.5rem',
            height: '1.5rem',
            width: '1.5rem'
          }}
        />
      </Tooltip>
    );
  }
  if (label === ASSET_DATA_PROVIDERS.MANUAL) {
    return (
      <Tooltip
        title={
          ASSET_DATA_PROVIDER_LABELS[
            label as keyof typeof ASSET_DATA_PROVIDER_LABELS
          ]
        }
        key={label}
      >
        <IconButton
          key={label}
          disableRipple
          disableFocusRipple
          size="small"
          sx={{
            p: 0,
            mr: 1,
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: 'transparent',
            color: 'text.secondary',
            borderRadius: 0.5,
            width: '1.5rem',
            height: '1.5rem',
            minWidth: '1.5rem',
            minHeight: '1.5rem'
          }}
        >
          <FontAwesomeIcon size="xs" icon={faUpload} />
        </IconButton>
      </Tooltip>
    );
  }
  return null;
};

export default AssetProviderLogo;
